import {
  ActionIcon,
  Group,
  Text,
  useComputedColorScheme,
  useMantineColorScheme,
} from "@mantine/core";
import { Link, Outlet } from "@tanstack/react-router";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppTheme } from "../context/AppTheme";
import { BrandLogo } from "./BrandLogo";
import { LanguageSwitcher } from "./LanguageSwitcher";
import styles from "./PublicLayout.module.css";

function ColorSchemeToggle() {
  const { t } = useTranslation();
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme("light", {
    getInitialValueInEffect: true,
  });
  return (
    <ActionIcon
      onClick={() => setColorScheme(computed === "light" ? "dark" : "light")}
      variant="subtle"
      size="lg"
      aria-label={t("nav.toggleColorScheme")}
    >
      {computed === "light" ? (
        <Moon size={18} strokeWidth={1.5} />
      ) : (
        <Sun size={18} strokeWidth={1.5} />
      )}
    </ActionIcon>
  );
}

export function PublicLayout() {
  const { t } = useTranslation();
  const { themeName } = useAppTheme();

  return (
    <div className={styles.root}>
      <div className={styles.meshBg} aria-hidden="true" />
      <div className={styles.grain} aria-hidden="true" />
      <header className={styles.header}>
        <Link to="/" className={styles.logoLink} aria-label={t("app.title")}>
          {themeName === "belora" ? (
            <BrandLogo height={24} data-testid="layout-brand-title" />
          ) : (
            <Text
              size="sm"
              fw={600}
              tt="uppercase"
              data-testid="layout-brand-title"
            >
              {t("app.title")}
            </Text>
          )}
        </Link>
        <Group gap="xs">
          <LanguageSwitcher />
          <ColorSchemeToggle />
        </Group>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
